import { render, staticRenderFns } from "./menu-right.vue?vue&type=template&id=f60b7794&scoped=true"
import script from "./menu-right.vue?vue&type=script&lang=js"
export * from "./menu-right.vue?vue&type=script&lang=js"
import style0 from "./menu-right.vue?vue&type=style&index=0&id=f60b7794&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60b7794",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f60b7794')) {
      api.createRecord('f60b7794', component.options)
    } else {
      api.reload('f60b7794', component.options)
    }
    module.hot.accept("./menu-right.vue?vue&type=template&id=f60b7794&scoped=true", function () {
      api.rerender('f60b7794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-manage/components/menu-right.vue"
export default component.exports